import { Component } from 'react';
import withAuth from '../withAuth';
import {compose} from "redux";
import {connect} from "react-redux";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Signature from '../Signature/Signature';
import './SignatureCard.css'
import {setRaCompanies, setSppCompanies, toShortName} from '../../redux/analyseRisques/analyseRisquesActions'
import {arIsReadonly} from "../../redux/analyseRisques/analyseRisquesStatusActions";
import {TYPING_TIMEOUT} from '../../constants'
import CustomizedTextField from '../Input/CustomizedTextField';

class SignatureCard extends Component {

    constructor(props){
        super(props);
        this.state = {
            editionMode: false,
            name: props.currentCompany.name,
            email: props.currentCompany.email,
            nameTypingTimeout: null,
            emailTypingTimeout: null,
            timeout: TYPING_TIMEOUT,
        }
    }

    editSignature(){
        this.setState({
            editionMode: true,
        })
    }

    onMailChange(event){
        let value = event.target.value;

        if (this.state.emailTypingTimeout) {
            clearTimeout(this.state.emailTypingTimeout);
        }

        this.setState({
            email: value,
            emailTypingTimeout: setTimeout(() => {

                if(this.props.moduleSpp){
                    let companies = this.props.sppCompanies.slice(0);
                    let company = companies.find((c) => c.id === this.props.currentCompany.id);
                    company.email = value;
                    this.props.setSppCompanies(companies);
                } else {
                    let companies = this.props.raCompanies.slice(0);
                    let company = companies.find((c) => c.id === this.props.currentCompany.id);
                    company.email = value;
                    this.props.setRaCompanies(companies);
                }
            }, this.state.timeout)
        });
    }

    onNameChange(event){
        let value = event.target.value;

        if (this.state.nameTypingTimeout) {
            clearTimeout(this.state.nameTypingTimeout);
        }

        this.setState({
            name: value,
            nameTypingTimeout: setTimeout(() => {
                if(this.props.moduleSpp){
                    let companies = this.props.sppCompanies.slice(0);
                    let company = companies.find((c) => c.id === this.props.currentCompany.id);
                    company.name = value;
                    this.props.setSppCompanies(companies);
                } else {
                    let companies = this.props.raCompanies.slice(0);
                    let company = companies.find((c) => c.id === this.props.currentCompany.id);
                    company.name = value;
                    this.props.setRaCompanies(companies);
                }
            }, this.state.timeout)
        });
    }

    onValidateSignature(value){

        let companies;

        if(this.props.sppTab)
            companies = this.props.sppCompanies.slice(0);
        else{
            companies = this.props.raCompanies.slice(0);
        }

        let company = companies.find((c) => c.id === this.props.currentCompany.id);

        company.signature = value;

        if(this.props.sppCard){
            this.props.setSppCompanies(companies);
        } else {
            this.props.setRaCompanies(companies);
        }

        this.close();
    }

    close(){
        this.setState({
            editionMode:false
        });
    }

    render() {
        let readonly = (this.props.moduleSpp && !this.props.sppTab) || arIsReadonly(this.props.header);

        return (
            <div className="col-lg-4 col-md-6 col-sm-12 col-12 risk-card-container">
                <Card className={ "without-padding card " + (readonly ? 'disabled' : '')}>
                    <CardHeader style={{ color: 'rgb(117, 117, 117)' }} title={"Signature " + toShortName(this.props.currentCompany)}/>
                    <CardContent className="without-padding without-line-height">
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                <CustomizedTextField
                                    id={this.props.index + "-name"}
                                    required
                                    label={"Nom"}
                                    className="full_size"
                                    value={this.state.name}
                                    onChange={this.onNameChange.bind(this)}
                                />
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                                <CustomizedTextField
                                    id={this.props.index + "-mail"}
                                    required
                                    label={"Email"}
                                    className="full_size"
                                    value={this.state.email}
                                    onChange={this.onMailChange.bind(this)}/>
                            </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top row">
                            <Signature close={this.close.bind(this)} open={this.editSignature.bind(this)}
                                currentSignature={this.props.currentCompany.signature} onValidateSignature={this.onValidateSignature.bind(this)}
                                onRef={ref => (this.signature = ref)} editionMode={this.state.editionMode}/>
                        </div>
                    </CardContent>
                </Card>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        header: state.analyseRisques.header,
        raCompanies: state.analyseRisques.raCompanies,
        sppCompanies: state.analyseRisques.sppCompanies,
        moduleSpp: state.analysesRisques.moduleSpp,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setRaCompanies: (companies) => dispatch(setRaCompanies(companies)),
        setSppCompanies: (companies) => dispatch(setSppCompanies(companies)),
    };
};

export default compose(withAuth, connect(mapStateToProps, mapDispatchToProps))(SignatureCard);
